import React from 'react';

import VistaEtiquetas from '../Compartidas/VistaEtiquetas';

import EtiquetasBlogsHelper from '../../Helpers/EtiquetasBlogs';

const USADO_EN = { singular: 'blog', plural: 'blogs' };

const EtiquetasBlogs = () => (
    <VistaEtiquetas
        helper={EtiquetasBlogsHelper}
        seccion='Blogs'
        encabezado='Etiquetas de blogs'
        usadoEn={USADO_EN}
        ubicacion='Se asigna a los blogs al editarlos.'
    />
);

export default EtiquetasBlogs;
